import axios from "axios";
import _ from "lodash";
import {
	WP_ENDPOINT,
	WP_LIBRARY_BOOKS,
	WP_LIBRARY_ALBUMS
} from ".././config";


export async function fetchAllBooks() {
	let books = await axios.get(WP_ENDPOINT + WP_LIBRARY_BOOKS, {
		params: {fields:'id,acf.title,acf.category,acf.cover,acf.cover_color'}
	});

	let categories = _.uniq(_.map(books.data, category => category.acf.category));
	
	books = _.map(categories , category => {
		return {
			category: category,
			books: _.filter(books.data, function(book){
				return book.acf.category == category;
			})
		}
	})
	
	return books;
}

export async function fetchAllAlbums() {
	let books = await axios.get(WP_ENDPOINT + WP_LIBRARY_ALBUMS, {
		params: {fields:'id,acf.title,acf.cover,acf.cover_color'}
	});
	
	return books.data;
}


// WEBPACK FOOTER //
// ./src/store/services/LibraryFeed/index.js